var $4e3bc8cf783ad569$exports = {};
$4e3bc8cf783ad569$exports = {
  "rangeOverflow": args => `Hodnota mus\xed by\u{165} ${args.maxValue} alebo skor\u{161}ia.`,
  "rangeReversed": `D\xe1tum za\u{10D}iatku mus\xed by\u{165} skor\u{161}\xed ako d\xe1tum konca.`,
  "rangeUnderflow": args => `Hodnota mus\xed by\u{165} ${args.minValue} alebo neskor\u{161}ia.`,
  "unavailableDate": `Vybrat\xfd d\xe1tum je nedostupn\xfd.`
};
export { $4e3bc8cf783ad569$exports as default };